<div mat-dialog-title class="dialog-header">
    <span class="title">
        {{ titleLocalizationKey | i18next }}
    </span>
    <span class="close-text-snippet-icon">
        <mat-icon (click)="closeDialog()" svgIcon="interface-delete 1"></mat-icon>
    </span>
</div>
<div mat-dialog-content class="container dialog-content">
    <form [formGroup]="formGroup">
        <div class="form-field-row">
            <span class="form-field">
                <aum-input
                    placeholder="{{ 'aumico_reports_input_please_enter_placeholder' | i18next }}"
                    [aumFormControl]="formGroup.controls['description']"
                    [disabled]="editMode"
                >
                    <aum-form-field-label>
                        {{
                            'aumico_reports_organization_settings_text_snippets_form_dialog_description_field' | i18next
                        }}
                    </aum-form-field-label>
                    <aum-form-error
                        *ngIf="
                            formGroup.controls['description'].touched &&
                            formGroup.controls['description'].hasError('required')
                        "
                    >
                        <span>
                            {{
                                'aumico_reports_organization_settings_text_snippets_form_dialog_description_field_required_error'
                                    | i18next
                            }}
                        </span>
                    </aum-form-error>
                    <aum-form-error *ngIf="formGroup.controls['description'].hasError('descriptionExists')">
                        {{
                            'aumico_reports_organization_settings_text_snippets_form_dialog_description_field_already_exists_error'
                                | i18next
                        }}
                    </aum-form-error>
                </aum-input>
            </span>
            <span>
                <aum-input
                    placeholder="{{ 'aumico_reports_input_please_enter_placeholder' | i18next }}"
                    [aumFormControl]="formGroup.controls['title']"
                >
                    <aum-form-field-label>
                        {{ 'aumico_reports_organization_settings_text_snippets_form_dialog_title_field' | i18next }}
                    </aum-form-field-label>
                    <aum-form-error *ngIf="formGroup.controls['title'].touched && formGroup.controls['title'].invalid">
                        <span>
                            {{
                                'aumico_reports_organization_settings_text_snippets_form_dialog_title_field_required_error'
                                    | i18next
                            }}
                        </span>
                    </aum-form-error>
                </aum-input>
            </span>
        </div>
        <div>
            <div>
                <ham-tiptap-toolbar [editor]="tiptapEditor" (imageSelected)="onTiptapImageSelected($event)">
                    <div #tiptapHost class="tiptap-editor"></div>
                </ham-tiptap-toolbar>
            </div>
            <mat-error
                class="content-error"
                *ngIf="formGroup.controls['content'].touched && formGroup.controls['content'].invalid"
            >
                {{
                    'aumico_reports_organization_settings_text_snippets_form_dialog_content_field_required_error'
                        | i18next
                }}
            </mat-error>
        </div>
    </form>
</div>
<div class="actions-footer">
    <mat-dialog-actions>
        <button aum-button (click)="closeDialog()" color="basic">
            {{ 'aumico_reports_organization_settings_text_snippets_form_dialog_cancel_button' | i18next }}
        </button>

        <button aum-button [disabled]="formGroup.invalid" (click)="onSaveTextSnippetClicked()" color="primary">
            {{ 'aumico_reports_organization_settings_text_snippets_form_dialog_save_button' | i18next }}
        </button>
    </mat-dialog-actions>
</div>
